import React, { StrictMode } from 'react'
import { Navigate, Outlet } from 'react-router'
import { RequireAuth } from '@core/Components/RequireAuth'
import { useFeature } from '@core/Utils/hooks/useFeature'
import { AppRoutes } from '@core/AppRoutes'
import { useShouldStartOnboarding } from './hooks/useShouldStartOnboarding'
import { OnboardingManager } from './Components/OnboardingManager'

export const FollowMeRoot: React.FC = () => {
  return (
    <RequireAuth>
      <FollowMeRootComponent />
    </RequireAuth>
  )
}

// ===============
// Local Component
// ===============

const FollowMeRootComponent = () => {
  const isFollowMeFeatureActive = useFeature('content-hub-follow-me')

  const { onboardingStatus, handleOnboardStatusSuccess } = useShouldStartOnboarding()

  if (!isFollowMeFeatureActive) {
    return <Navigate to={AppRoutes.Home} />
  }

  if (onboardingStatus === 'checking') {
    return null
  }

  if (onboardingStatus === 'no-profile-found') {
    return <OnboardingManager onCompleteOnboarding={handleOnboardStatusSuccess} />
  }

  return (
    <StrictMode>
      <Outlet />
    </StrictMode>
  )
}
